import { Navigate, Route, useLocation } from "react-router-dom";
import * as RouteConstants from "../constants/RouteConstants";

// Paths that moved when Reports got its Saved reports tab. Old bookmarks land
// on the new path with their query string. "/my-team/reports" needs no entry:
// it is now the parent of the My team report screen, and Home's menu routes
// redirect every parent to its index child.
export const LEGACY_REDIRECTS = [
  { from: "/reports/list", to: RouteConstants.APP_ROUTE_REPORTS_LIST },
];

const RedirectKeepingQuery = ({ to }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

export const renderLegacyRedirects = () =>
  LEGACY_REDIRECTS.map(({ from, to }) => (
    <Route key={from} path={from} element={<RedirectKeepingQuery to={to} />} />
  ));
